import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject
} from '@angular/core';
import { widgetInfo } from "../wm-canvas-dom.component";
import { EventManagerService } from "@wms/app";

let ACTIONS = {ADD: 1, MOVE: 2};

@Directive({
  selector: '[wmsDraggable]',
  standalone: true
})
export class WmsDraggableDirective implements AfterViewInit {
  public canvasElDragStartEvent = new EventEmitter();
  public canvasElDragEndEvent = new EventEmitter();

  @HostListener('dragstart', ['$event.target'])
  onDragStart(el: HTMLElement) {
      let widgetDefaultsObj: {[key: string]: any} = {};
      // Get the value of the data-widget-defaults attribute using getAttribute
      const widgetDefaults: string | null = el.getAttribute('data-widget-defaults');
      // Parse the widgetDefaults string into an object using JSON.parse
      if (widgetDefaults) {
        widgetDefaultsObj = JSON.parse(widgetDefaults);
      }
      this.eventManager.onDrag({
        widgetType: el.getAttribute('data-widget-type'),
        widgetDefaults: widgetDefaultsObj,
        widgetDropEffect: el.getAttribute('data-widget-drop-effect')
      });
      const dragEvent = event as DragEvent;
      if (dragEvent?.dataTransfer?.setDragImage) {
        dragEvent.dataTransfer.setDragImage(el, 0, 0);
      }
  }

  @HostListener('dragend', ['$event'])
  onDragEnd(e: Event) {
    this.eventManager.emitcanvasAddWidgetDragEndEvent();
  }

  private $focusNode = $('.wm-focus-rect');
  private addWidgetInfo: widgetInfo = {};
  private action: number | undefined;
  private lastHoverWidId: any;
  private addPosDetermined: any;
  private eventManager: EventManagerService;

  constructor(element: ElementRef) {
    this.eventManager = inject(EventManagerService);
  }

  ngAfterViewInit() {}

  // private cleanupAddWidCancel() {
  //   this.addPosDetermined = false;
  //   this.lastHoverWidId = undefined;
  //   this.action = undefined;
  //   this.addWidgetInfo = undefined;
  //   this.$focusNode.removeClass('ng-hide');
  //   $$canvas.after(this.$dropPrediction);
  //   removeDropPreditionClsFromParent();
  // }

}
